import { profileState } from "@/atoms/user/profile-state";
import { ButtonColor } from "@/common/enum/button-color";
import { PartnerOrderManagePath } from "@/common/enum/path";
import { formatDateToYYYYMMDDhhmm } from "@/common/util/date-util";
import { OrderDetailDto } from "@/types/dto/order-detail-dto";
import { Button } from "flowbite-react";
import { Link } from "react-router-dom";
import { useRecoilState } from "recoil";
import { OrderPDFDownloadButton } from "../button/OrderPDFDownloadButton";
import { Body16Medium } from "../typography/Body16Medium";
import { H3 } from "../typography/H3";

interface Props {
  orderDetail: OrderDetailDto;
}

export const PartnerCompleteOrderPanel: React.FC<Props> = ({ orderDetail }) => {
  const [profile, setProfile] = useRecoilState(profileState);

  if (!profile) {
    return null;
  }

  return (
    <div className="flex flex-col justify-center items-center py-[32px] px-[16px] gap-[16px] rounded-lg border-[1px] border-semantic-divider bg-primary-white">
      <H3 className="text-semantic-text-heading">
        발주가 정상적으로 완료되었습니다.
      </H3>
      <div className="flex gap-[16px]">
        <Body16Medium className="text-semantic-text-secondary">
          발주번호: {orderDetail.invoiceNumber}
        </Body16Medium>
        <Body16Medium className="text-semantic-text-secondary">
          {`발주일자: ${formatDateToYYYYMMDDhhmm(orderDetail.createdAt)}`}
        </Body16Medium>
      </div>
      <div className="flex gap-[16px]">
        <Link to={PartnerOrderManagePath.MANAGE_ORDER}>
          <Button color={ButtonColor.PRIMARY_OUTLINE}>
            발주 내역으로 이동하기
          </Button>
        </Link>
        <OrderPDFDownloadButton orderDetail={orderDetail} profile={profile}>
          <Button color={ButtonColor.PRIMARY}>발주서 다운로드</Button>
        </OrderPDFDownloadButton>
      </div>
    </div>
  );
};
